import { API, setAuthToken } from "../../../config/API.js";

export const getValuesData = () => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/values`);
};

export const updValuesData = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/values/edit", params);
};
